/* eslint-disable max-len */
/**
 * JS dependencies
 */
import 'jquery';
import 'angular';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-animate';
import modal from 'angular-ui-bootstrap/src/modal';
import tooltip from 'angular-ui-bootstrap/src/tooltip';
import datepicker from 'angular-ui-bootstrap/src/datepicker';
import dropdown from 'angular-ui-bootstrap/src/dropdown';
import typeahead from 'angular-ui-bootstrap/src/typeahead';
import tabs from 'angular-ui-bootstrap/src/tabs';
import collapse from 'angular-ui-bootstrap/src/collapse';
import buttons from 'angular-ui-bootstrap/src/buttons';
/**
 * Reused SearchJS dependencies
 */
import 'lodash';
import qs from 'qs';
import '../../../../lib/assets/javascripts/devex/urls';
import '../../../../lib/assets/javascripts/devex/browser_url';
import '../../../../lib/assets/javascripts/devex/search/filter';
import '../../../../lib/assets/javascripts/devex/search/pagination';
import '../../../../lib/assets/javascripts/devex/search/sorting';
import '../../../../lib/assets/javascripts/devex/search/searchJS';
import '../../../../lib/assets/javascripts/devex/angular/searchJS';
/**
 * Reused Devex Directives and Components
 */
import '../../../../lib/assets/javascripts/devex/angular/directives/pagination/pagination.directive';
import '../../../../lib/assets/javascripts/devex/angular/directives/pagination-info';
import '../../directives/keypress-events';
import '../../components/cloudinary_image/cloudinary_image.component';
/**
 * Bookmarked searches
 */
import '../../../../lib/assets/javascripts/devex/alerts';
import '../../../../lib/assets/javascripts/devex/angular/request_transformers';
import '../../../../lib/assets/javascripts/devex/angular/filters/my_alert';
import '../../../../lib/assets/javascripts/devex/angular/filters/bookmarked_search_ownership';
import './models/bookmarked_search_service';
import '../../../../lib/assets/javascripts/devex/angular/models/bookmarked-search';
import './directives/bookmarked_searches/bookmarked_searches';
import './directives/bookmarked_searches/bookmarked_searches_list';
import './directives/bookmarked_searches/bookmarked_searches_create';
import './directives/bookmarked_searches/bookmarked_searches_edit';
import '../../directives/spinner/spinner.directive';
/**
 * Reused Devex Visualizations directives
 */
import '../../../../lib/assets/javascripts/devex/angular/directives/visualizations/charts/pie-chart.directive';
import '../../../../lib/assets/javascripts/devex/angular/directives/visualizations/charts/bar-chart.directive';
import '../../../../lib/assets/javascripts/devex/angular/directives/visualizations/charts/timeline-chart.directive';
/**
 * Reused Devex services
 */
import '../../../assets/javascripts/funding/shared/date_filter.service';
/**
 * Reused Devex helpers
 */
import '../../angular/services/slug_and_id.service';
import '../../../../lib/assets/javascripts/devex/angular/services/spinner.service';
import '../../../../lib/assets/javascripts/devex/ui-utils';
import '../../../../lib/assets/javascripts/devex/util';
import '../../../../lib/assets/javascripts/devex/angular/services/error_reporting.service';
/**
 * Reused Devex filters
 */
import '../../utilities/angular/days_ago';
import '../../angular/filters/format_date';
import '../../angular/filters/format_duration';
import '../../angular/filters/report_type_display';
import '../../angular/filters/add_trailing_space';
import '../../../../lib/assets/javascripts/devex/angular/filters/humanize';
/**
 * Funding Search services
 */
import './services/report_api.service';
import './services/url_handling.service';
import './services/organization.service';
/**
 * Funding Search Directives
 */
import './directives/track_report_button.directive';
import './directives/visualizations_button.directive';
import './directives/report_details.directive';
import './directives/action_bar.directive';
import './directives/report_description.directive';
import './directives/report_shortlisted.directive';
import './directives/report_timeline.directive';
import './directives/report_contacts.directive';
import './directives/report_header.directive';
import './directives/search_bar.directive';
import './directives/search_results.directive';
import './directives/container.directive';
/**
 * Funding Search Components
 */
import './components/report_summary.component';
import './components/visualizations_container.component';
import './components/lifecycle.component';
import './components/report_result.component';
import './components/funders_chart.component';
import './components/places_chart.component';
import './components/news_topics_chart.component';
/**
 * Back to top button
 */
import { addBackToTop, DEFAULT_SETTINGS } from '../../components/back_to_top/back_to_top';
/* eslint-enable max-len */

addBackToTop({ ...DEFAULT_SETTINGS, zIndex: 1000 });

window.$.deparam = qs.parse;

const moduleDependencies = [
  'devex.search',
  'directives.paginationInfo',
  'directives.pagination',
  'directives.keypressEvents',
  'directives.visualizations.emptyResults',
  'directives.visualizations.chartLabel',
  'directives.visualizations.chartLegend',
  'directives.visualizations.pieChart',
  'directives.visualizations.barChart',
  'directives.visualizations.timelineChart',
  'fundingSearchApp.models.reportApiService',
  'fundingSearchApp.services.urlHandlingService',
  'models.bookmarkedSearchService',
  modal,
  tooltip,
  datepicker,
  dropdown,
  tabs,
  collapse,
  buttons,
  typeahead,
  'filters.daysAgo',
  'filters.formatDate',
  'filters.formatDuration',
  'filters.reportTypeDisplay',
  'filters.addTrailingSpace',
  'filters.humanize',
  'ngSanitize',
  'ngAnimate',
  'components.cloudinaryImage',
  'fundingSearchApp.directives.container',
  'fundingSearchApp.directives.searchBar',
  'fundingSearchApp.directives.visualizationsButton',
  'fundingSearchApp.components.visualizationsContainer',
  'fundingSearchApp.directives.searchResults',
  'fundingSearchApp.components.reportResult',
  'fundingSearchApp.directives.actionBar',
  'fundingSearchApp.directives.trackReportButton',
  'fundingSearchApp.directives.reportDescription',
  'fundingSearchApp.directives.reportShortlisted',
  'fundingSearchApp.directives.reportTimeline',
  'fundingSearchApp.components.reportSummary',
  'fundingSearchApp.components.lifecycle',
  'fundingSearchApp.directives.reportContacts',
  'fundingSearchApp.directives.reportHeader',
  'fundingSearchApp.directives.reportDetails',
  'fundingSearchApp.components.fundersChart',
  'fundingSearchApp.components.placesChart',
  'fundingSearchApp.components.newsTopicsChart',
  'fundingSearchApp.services.dateFilterService',
  'directives.bookmarkedSearches',
  'fundingSearchApp.services.Organization',
  'services.SpinnerService',
  'services.SlugAndIdService',
  'services.ErrorReportingService',
  'services.ChartService',
];

angular.module('fundingSearchApp', moduleDependencies);
